<template>

<app-page v-if="is.loaded" :title="(isSessionCustomer) ? page.customer_title : page.business_title">

	<app-inner :condensed="true">

		<com-row v-if="isSessionCustomer">

			<com-cell to="Account/Profile" icon="profile" :text="page.customer_box_edit" />
			<com-cell to="Account/Offers" icon="offers" :text="page.customer_box_offers" :count="session.count.offers" />
			<com-cell to="Account/Reviews" icon="reviews" :text="page.customer_box_reviews" :count="session.count.reviews" v-if="!window.is.mobile" />

		</com-row>

		<com-row v-if="isSessionCustomer">

			<com-cell to="Account/Reviews" icon="reviews" :text="page.customer_box_reviews" :count="session.count.reviews" v-if="window.is.mobile" />
			<com-cell to="Account/Refer" icon="refer" :text="page.customer_box_refer" />
			<com-cell to="Account/Events" icon="events" :text="page.customer_box_events" />
			<com-cell to="Vacancies" icon="search" :text="page.customer_box_vacancies" />
			<com-cell to="Home" icon="review" :text="page.customer_box_home" />

		</com-row>

		<com-row v-if="isSessionBusiness">

			<com-cell to="Account/Profile" icon="business" :text="page.business_box_edit" />
			<com-cell to="Account/Reviews" icon="reviews" :text="page.business_box_reviews" :count="session.business.count.reviews" />
			<com-cell to="Account/Incentives" icon="offers" :text="page.business_box_bonus" v-if="!window.is.mobile" :premium="true" />
			<com-cell to="Account/Profile/Vacancies" icon="vacancy" :text="page.business_box_vacancies" :premium="true" />

		</com-row>

		<com-row v-if="isSessionBusiness">

			<com-cell to="Account/Incentives" icon="offers" :text="page.business_box_bonus" v-if="window.is.mobile" :premium="true" />
			<com-cell to="Account/Adverts" icon="advert" :text="page.business_box_adverts" :premium="true" />
			<com-cell to="Account/Suppliers" icon="supplier" :text="page.business_box_suppliers" :premium="true" />
			<com-cell to="Account/Resources" icon="resource" :text="page.business_box_resources" :premium="true" />

		</com-row>

        <com-status v-if="isSessionBusiness" />
	
	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comRow from './dashboard/Row'
import comCell from './dashboard/Cell'
import comStatus from './dashboard/Status'

export default {

	mixins: [mixinPage],

	components: {
		'com-row': comRow,
        'com-cell': comCell,
        'com-status': comStatus
	},

	created: function() {

		if (this.isSessionBusiness && !this.session.terms) this.$router.push({
			name: 'Account/Complete'
		})

	}

}

</script>